<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getHighFeaturesGeoJson.data.id"
      :source="getHighFeaturesGeoJson"
      :layerId="getHighLineLayer.id"
      :layer="getHighLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getLowFeaturesGeoJson.data.id"
      :source="getLowFeaturesGeoJson"
      :layerId="getLowLineLayer.id"
      :layer="getLowLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getHighFeaturesGeoJson.data.id"
      :source="getHighFeaturesGeoJson"
      :layerId="getHighPointsLayer.id"
      :layer="getHighPointsLayer"
    />
    <MglGeojsonLayer
      :sourceId="getLowFeaturesGeoJson.data.id"
      :source="getLowFeaturesGeoJson"
      :layerId="getLowPointsLayer.id"
      :layer="getLowPointsLayer"
    />
  </div>
</template>

<script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "VoyageMeshLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "getHighFeaturesGeoJson",
      "getLowFeaturesGeoJson",
    ]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getHighPointsLayer",
      "getLowPointsLayer",
      "getHighLineLayer",
      "getLowLineLayer",
    ]),
  },
};
</script>
